import { render, staticRenderFns } from "./search-component.vue?vue&type=template&id=070677a8&scoped=true"
import script from "./search-component.vue?vue&type=script&lang=js"
export * from "./search-component.vue?vue&type=script&lang=js"
import style0 from "./search-component.vue?vue&type=style&index=0&id=070677a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070677a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
